import type {ReactElement} from 'react';
import React from 'react';
import {SkeletonBrick} from '@Components/skeleton-brick';
import styles from './add-item-skeleton.module.scss';

export function AddItemSkeleton(): ReactElement<any> {
  return (
    <div className={`${styles.container} spacing-m-b-4 flex-v-row flex-align-items-center`}>
      <SkeletonBrick width={32} height={32} radius="1000px" />
      <SkeletonBrick width={60} height={8} />
    </div>
  );
}
